import React, { useCallback } from 'react';
import debounce from 'lodash.debounce';
import { FaSearch } from 'react-icons/fa';

import { useLocation, useNavigate } from 'react-router-dom';

import api from 'services/api';

import Input from 'components/Input';
import Text from 'v3/components/Text';
import Label from 'components/Label';
import AsyncSelect from 'react-select/async';
import { useNotificationCounter } from 'hooks';
import theme from 'v3/theme';

import { Col, Row } from 'react-bootstrap';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function ConversationSearch({
  setLoadNumber,
  setFilters,
  filters,
  totalDeals,
  loading,
  setPage
}) {
  const labelStyle = { color: theme.colors.dark, fontWeight: 500 };
  const selectStyles = {
    placeholder: (base) => ({ ...base, color: theme.colors.dark }),
    input: (base) => ({ ...base, color: theme.colors.dark }),
    singleValue: (base) => ({ ...base, color: theme.colors.dark }),
    multiValueLabel: (base) => ({ ...base, color: theme.colors.dark }),
  };

  const { setCostCenters } = useNotificationCounter();

  const handleInputChange = useCallback(
    debounce((value) => {
      setLoadNumber(value);
      setPage(0);
    }, 600),
    [],
  );

  const onChange = (e) => {
    handleInputChange(e.target.value);
  };

  const handleSearch = (value) => {
    handleInputChange.cancel();
    setLoadNumber(value);
    setPage(0);
  };

  async function fetchCostCenters(search) {
    try {
      const response = await api.get(`v3/cost-center`, {
        params: { search },
      });

      return response.data;
    } catch (ex) {
      return [];
    }
  }

  function handleSelectedCostCenters(selected) {
    if (selected) {
      setFilters((old) => ({
        ...old,
        cost_centers: selected
      }))
      // Sincronizar com contexto global
      setCostCenters(selected);
    } else {
      setFilters((old) => ({
        ...old,
        cost_centers: []
      }))
      // Sincronizar com contexto global
      setCostCenters([]);
    }
  }

  return (
    <>
      <Row style={{ display: 'flex', flexDirection: 'column', gap: '10px', margin: '15px 0px' }}>
        <Col>
          <Label className="textLabel" style={labelStyle}>
            Centro de Custo
          </Label>
          <AsyncSelect
            noOptionsMessage={() => <span>Digite um Centro de Custo</span>}
            placeholder="Selecione"
            isMulti
            styles={selectStyles}
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.id}
            loadOptions={fetchCostCenters}
            loadingMessage={() => <span>Carregando...</span>}
            onChange={handleSelectedCostCenters}
            value={filters?.cost_centers}
          />
        </Col>
        <Col>
          <div className="chat-load-search-wrapper">
            <Input
              label="Número da Carga"
              labelColor={theme.colors.dark}
              textColor={theme.colors.dark}
              onChange={onChange}
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  handleSearch(event.target.value);
                }
              }}
              disabled={loading}
              style={{ paddingRight: '34px' }}
            />
            <button
              type="button"
              className="chat-load-search-button"
              title="Pesquisar carga"
              onClick={(event) => {
                const input =
                  event.currentTarget.parentElement.querySelector('input');
                handleSearch(input?.value || '');
              }}
              disabled={loading}
            >
              <FaSearch size={13} />
            </button>
          </div>
        </Col>
        <Col>
          {loading ? null : (
            <Text color="#747A87" weight={500}>
              {totalDeals || 0} Cargas
            </Text>
          )}
        </Col>
      </Row>
    </>
  );
}

export default ConversationSearch;
